import axios, { AxiosRequestConfig } from 'axios';
import { IconButton } from 'components/atoms';
import { columnType } from 'components/molecules';
import { paginationModelType, sortModelType } from 'components/organisms';
import { GET_USERS } from 'const';
import { tableModelType } from 'hooks/useTable';
import { AiOutlineCheck, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { PaginationType, User } from 'types';
import { ListUserTemplateFilterType } from './ListUserTemplate.schema';

export const defaultPagination: paginationModelType = {
  page: 0,
  rowsPerPage: 15,
  rowsCount: 0,
};

export const defaultSortModel: sortModelType<User> = {
  field: 'id',
  order: 'ASC',
};

export const defaultListUserTemplateFilter: ListUserTemplateFilterType = {
  username: undefined,
};

export const getColumns: (
  onDelete: (id: number) => void,
  onActive: (id: number) => void,
) => columnType<User>[] = (onDelete, onActive) => [
  {
    field: 'username',
    headerName: 'Nombre de usuario',
    flex: '5',
    exportField: true,
    render: ({ username }) => username,
  },
  {
    field: 'id',
    table: 'role',
    headerName: 'Roles',
    flex: '4',
    exportField: true,
    render: ({ roles }) =>
      roles ? roles.map((role) => role.name).join(', ') : '',
  },
  {
    field: 'enabled',
    headerName: 'Estado',
    flex: '1',
    // disabledSort: true,
    render: ({ enabled }) => (enabled ? 'Activo' : 'Inactivo'),
  },
  {
    field: 'actions',
    headerName: 'Acciones',
    // align: "flex-end",
    flex: '2',
    disabledSort: true,
    render: ({ id, enabled }) => (
      <>
        <IconButton
          info={enabled ? 'Desactivar usuario' : 'Activar usuario'}
          color={enabled ? 'success' : 'grey'}
          onClick={() => onActive(id)}
        >
          <AiOutlineCheck />
        </IconButton>
        <IconButton
          info="Editar usuario"
          positionEdge="start"
          color="grey"
          href={`/pages/management/user/${id}/edit`}
        >
          <AiOutlineEdit />
        </IconButton>
        <IconButton
          info="Eliminar usuario"
          positionEdge="start"
          color="error"
          onClick={() => onDelete(id)}
        >
          <AiOutlineDelete />
        </IconButton>
      </>
    ),
  },
];

export const fetchProcess = (
  { filterModel, sortModel, paginationModel }: tableModelType<User>,
  config?: AxiosRequestConfig<User>,
) => {
  return axios.get<PaginationType<User>>(
    `${GET_USERS}?${
      filterModel && filterModel.length > 0
        ? `filter=${JSON.stringify(filterModel)}&`
        : ''
    }${sortModel ? `sort=${JSON.stringify(sortModel)}&` : ''}${
      paginationModel
        ? `limit=${paginationModel.rowsPerPage}&page=${paginationModel.page}`
        : ''
    }`,
    config,
  );
};
